export default __webpack_public_path__ + "static/media/ai_virtual_services_generated_photos_fr.4d68d10f.png";